import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import useFetch from '../../../../components/hooks/useFetch.js';
import Input from '../../../../components/form/Input.js';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './TelaDelegacaoAcesso.scss';
import { getIPAddress } from '../../../../components/utils/GetIPAddress.js';
import {
  PESQUISA_PERMISSIONARIOS_PAGINADO,
  PERMISSIONARIO_EXCLUIR,
} from '../../../../services/delegacaoAcesso.js';
import { MEUCORREIOS_PESQUISA } from '../../../../services/meuCorreios.js';
import ModalDialog from '../../../../components/modal/ModalDialog.js';
import Tabela from './TabelaDelegacao.js';
import FormNovoPermissionario from './FormNovoPermissionario.js';
import FormVisualizar from './FormVisualizar.js';
import useModalConfirmacao from '../../../../components/hooks/useModalConfirmacao.js';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog.js';
import Paginador from '../../../../components/paginador/Paginador';

const TelaDelegacaoAcesso = () => {
  const methods = useForm({});
  const navigate = useNavigate();
  const [ipAddress, setIpAddress] = useState('');
  const location = useLocation();
  const dados = location.state.dados;
  const dadosPerfil = location.state.dadosPerfil;
  const filtrosDelegacao = location.state.filtrosDelegacao;
  const [dadosEmpresa, setDadosEmpresa] = useState();
  const { request: requestPermissionarios, data: dadosPermissionarios } =
    useFetch();
  const { request: requestEmpresa, data: empresa } = useFetch();
  const [modalAbertoNovoPermissionario, setModalAbertoNovoPermissionario] =
    useState(false);
  const [modalAbertoVisualizar, setModalAbertoVisualizar] = useState(false);
  const [permissionarioSelecionado, setPermissionarioSelecionado] = useState();
  const [pesquisar, setPesquisar] = useState(false);
  const { abreModalConfirmacao } = useModalConfirmacao();
  const [itensMarcados, setItensMarcados] = useState([]);

  const { request } = useFetch();
  const [filtros, setFiltros] = useState({
    page: 0,
  });

  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  console.log(filtrosDelegacao);
  useEffect(() => {
    setFiltros(filtrosDelegacao);
  }, [filtrosDelegacao]);
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  useEffect(() => {
    if (dadosEmpresa?.idCorreios) {
      requestPermissionarios(
        PESQUISA_PERMISSIONARIOS_PAGINADO(dadosEmpresa.idCorreios, filtros),
      );
    }
  }, [filtros]);
  const tableMetadata = [
    { key: 'nome', value: 'Nome' },
    { key: 'idCorreiosPF', value: 'Usuário' },
    {
      key: 'quantidadeContratos',
      value: 'Contratos',
      render: (text) => (text === ' ' ? '0' : text),
    },
    {
      key: 'quantidadeCentroCusto',
      value: 'Centro de Custos',
      render: (text) => (text === ' ' ? '0' : text),
    },
    {
      key: 'quantidadeSistemas',
      value: 'Sistemas',
      render: (text) => (text === ' ' ? '0' : text),
    },
  ];
  useEffect(() => {
    if (dados.tipo === 'PF') {
      requestEmpresa(MEUCORREIOS_PESQUISA(dadosPerfil.idCorreios));
    } else if (dados.tipo === 'PJ') {
      setDadosEmpresa(dados);
    } else {
      abreAlertaDialog('Tipo ' + dados.tipo + ' não definido.');
    }
  }, [dados]);

  useEffect(() => {
    if (empresa) setDadosEmpresa(empresa);
  }, [empresa]);

  useEffect(() => {
    if (dadosEmpresa?.idCorreios)
      requestPermissionarios(
        PESQUISA_PERMISSIONARIOS_PAGINADO(dadosEmpresa.idCorreios, filtros),
      );
  }, [dadosEmpresa]);

  useEffect(() => {
    if (dadosEmpresa?.idCorreios)
      requestPermissionarios(
        PESQUISA_PERMISSIONARIOS_PAGINADO(dadosEmpresa?.idCorreios, filtros),
      );
    setPesquisar(false);
  }, [pesquisar]);

  const chamaPrincipal = () => {
    navigate('/principal');
  };

  const chamaEdicao = (usuario) => {
    navigate('/delegacaoEdicao', {
      state: { dados, dadosPerfil, dadosEmpresa, usuario, filtros },
    });
  };

  const abreModalNovoPermissionario = () => {
    //setEnderecoSelecionado(item);
    setModalAbertoNovoPermissionario(true);
  };

  const fechar = () => {
    //setAlterei(true);
    setModalAbertoNovoPermissionario(false);
  };

  const abreModalVisualizar = (item) => {
    setPermissionarioSelecionado(item);
    setModalAbertoVisualizar(true);
  };

  const excluirPermissionario = (item) => {
    abreModalConfirmacao(
      `O Permissionário ${item.nome} será removido. Confirma ?`,
      () => excluiPermissionario(item),
    );
  };
  const excluiPermissionario = async (item) => {
    const { response } = await request(
      PERMISSIONARIO_EXCLUIR(item.idCorreios, item.idCorreiosPF, ipAddress),
    );
    if (response.ok) {
      abreAlertaDialog('Permissionário excluído com sucesso.');
      setPesquisar(true);
    }
  };

  const [searchTerm, setSearchTerm] = useState('');
  const [dadosPermissionariosFiltrado, setDadosPermissionariosFiltrado] =
    useState(dadosPermissionarios);
  const handleChangeFiltro = (event) => {
    const nomeOuIdCorreios = methods.getValues('nome');
    setFiltros({ ...filtros, nomeOuIdCorreios, page: 0 });
  };
  return (
    <>
      <div className="conteudo delegacao-acesso">
        <div className="delegacao-titulo">
          <h1>Delegação de acesso</h1>

          {/* SOMENTE PARA PF REPRESENTANTE DA EMPRESA */}
          <span className="subtitulo-p">
            Para: <b>{dadosEmpresa?.nome}</b>
          </span>
          {/* FIM - REPRESENTANTE DA EMPRESA */}
        </div>

        <div className="filtro-container bg-superficie">
          <div className="campo-txt">
            <label className="subtitulo-p" htmlFor="txt-input">
              Filtrar acessos:
            </label>
            <div className="input-container input-com-ic input-com-btn">
              <i className="ic-usuario input-ic"></i>
              <Input
                type="text"
                id="nome"
                name="nome"
                maxLength="500"
                placeholder="Nome ou Usuário"
                defaultValue={filtrosDelegacao?.nomeOuIdCorreios || ''}
                {...formMethods}
              />
              <button
                className="btn-txt so-icone input-btn"
                value="pesquisar"
                title="Filtrar"
                onClick={() => handleChangeFiltro()}
              >
                <i className="ic-filtro"></i>
              </button>
            </div>
            <div className="legenda mensagem">
              Filtrar por nome(s) ou usuário(s) separados por ;
            </div>
          </div>

          <button
            id="btn-novo-acesso"
            className="btn-pre btn-com-ic"
            onClick={() => abreModalNovoPermissionario()}
          >
            <i className="ic-usuario-adicionar"></i>
            Delegar novo acesso
          </button>
        </div>

        <h6>Usuários adicionados:</h6>

        <div className="lista-permissoes">
          <>
            {dadosPermissionarios && dadosPermissionarios.itens?.length > 0 ? (
              <div className="dados">
                <Tabela
                  dadosPagina={dadosPermissionarios.page}
                  acaoMudaPagina={(page) => setFiltros({ ...filtros, page })}
                  headers={tableMetadata}
                  dadosDelegacao={dadosPermissionarios.itens}
                  dados={dados}
                  dadosPerfil={dadosPerfil}
                  mostraColunaAcoes={true}
                  habilitaInformacao={(permissionario) => true}
                  ipAddress={ipAddress}
                  idCorreiosPJ={dadosEmpresa?.idCorreios}
                  acaoInformacao={(permissionario) => {
                    abreModalVisualizar(permissionario);
                  }}
                  habilitaEdicao={(permissionario) => true}
                  acaoEdicao={(permissionario) => {
                    chamaEdicao(permissionario);
                  }}
                  habilitaExclusao={(permissionario) => true}
                  acaoExclusao={(permissionario) => {
                    excluirPermissionario(permissionario);
                  }}
                />
              </div>
            ) : (
              <p
                style={{
                  backgroundColor: '#f0f0f0',
                  padding: '1rem',
                  textAlign: 'center',
                  borderRadius: '6px',
                  fontStyle: 'italic',
                  color: '#555',
                }}
              >
                Ainda não existem usuários adicionados.
              </p>
            )}
          </>
        </div>

        <div className="btns-row">
          <button className="btn-pre" onClick={() => chamaPrincipal()}>
            Voltar
          </button>
        </div>
      </div>

      <ModalDialog
        titulo="Delegar acesso a novos usuários"
        id="modal-novo"
        aberto={modalAbertoNovoPermissionario}
        setAberto={setModalAbertoNovoPermissionario}
        opcaoFechar={true}
      >
        <FormNovoPermissionario
          acaoCancelar={() => setModalAbertoNovoPermissionario(false)}
          acaoFechar={fechar}
          dados={dados}
          dadosEmpresa={dadosEmpresa}
          dadosPerfil={dadosPerfil}
        />
      </ModalDialog>

      <ModalDialog
        titulo={permissionarioSelecionado?.nome}
        id="modal-visualizar"
        dialogClassName="visualizar-acessos"
        aberto={modalAbertoVisualizar}
        setAberto={setModalAbertoVisualizar}
        opcaoFechar={true}
      >
        <FormVisualizar
          acaoCancelar={() => setModalAbertoVisualizar(false)}
          acaoFechar={fechar}
          idCorreios={dadosEmpresa?.idCorreios}
          permissionarioSelecionado={permissionarioSelecionado}
        />
      </ModalDialog>
    </>
  );
};

export default TelaDelegacaoAcesso;
